export function addAnimationComponents(modelEl) {
  if (!modelEl.components["animation-mixer"]) {
    return;
  }

  if (modelEl.hasAttribute("scriptable-model") || modelEl.hasAttribute("disable-default-animation")) {
    return;
  }

  // Respect explicitly set loop-animation on this element or descendants
  if (!modelEl.hasAttribute("loop-animation") && !modelEl.querySelector("[loop-animation]")) {
    modelEl.setAttribute("loop-animation", "");
  }
}
